import { useEffect, useState } from 'react';
import { DEVELOPER_MODE_CHANGED_EVENT, readDeveloperModeEnabled } from '@/lib/devMode';

/**
 * Reaktiver Developer-Mode-Status. Liefert `true`, solange der Developer Mode
 * aktiv ist (Standard AN). Aktualisiert sich SOFORT, wenn der Toggle in den
 * Einstellungen umgelegt wird — im selben Tab via CustomEvent, in anderen
 * Tabs via `storage`-Event. Dadurch passen sich Nav, Pakete usw. ohne Reload an.
 *
 * Verwendung für Sichtbarkeit von Superuser-Funktionen:
 *   const developerMode = useDeveloperMode();
 *   const effectiveSuperuser = echterSuperuser && developerMode;
 */
export function useDeveloperMode(): boolean {
  const [enabled, setEnabled] = useState<boolean>(readDeveloperModeEnabled);

  useEffect(() => {
    const sync = () => setEnabled(readDeveloperModeEnabled());
    window.addEventListener(DEVELOPER_MODE_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(DEVELOPER_MODE_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return enabled;
}
